import { gql } from '@apollo/client';

const ADD_CLIENT = gql`
    mutation MyMutation($brandName: String!, $contactName: String!, $email: String!, $phone: String!) {
        add_client(arg1: { brandName: $brandName, contactName: $contactName, email: $email, phone: $phone }) {
            organization {
                agency_id
                created_at
                id
                name
                status
            }
            organizationMember {
                created_at
                id
                organization_id
                role_id
                status
                user_id
            }
            user {
                agency_id
                created_at
                email
                first_name
                id
                image_url
                phone
            }
        }
    }
`;

const INVITE_CLIENT = gql`
    mutation InviteClient($email: String!, $message: String!) {
        client_invitation_create(arg1: { email: $email, message: $message }) {
            updated_at
            status
            created_at
            client_organization_id
            agency_id
            client_email
        }
    }
`;

const EDIT_CLIENT = gql`
    mutation UpdateClientContact(
        $clientId: uuid!
        $brand_name: String!
        $contact_id: uuid!
        $first_name: String
        $phone_number: String
        $description: String
    ) {
        update_client_organizations_by_pk(pk_columns: { id: $clientId }, _set: { name: $brand_name, description: $description }) {
            name
            description
            id
            logo_url
        }
        update_users_by_pk(pk_columns: { id: $contact_id }, _set: { first_name: $first_name, phone: $phone_number }) {
            phone
            image_url
            id
            first_name
            email
            agency_id
        }
    }
`;

const ADD_LOGO_TO_CLIENT = gql`
    mutation MyMutation($clientId: uuid!, $logoUrl: String!) {
        update_client_organizations_by_pk(pk_columns: { id: $clientId }, _set: { logo_url: $logoUrl }) {
            name
            logo_url
            id
        }
    }
`;

// eslint-disable-next-line import/prefer-default-export
export { ADD_CLIENT, EDIT_CLIENT, INVITE_CLIENT, ADD_LOGO_TO_CLIENT };
